"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = require("react");

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(n); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var useTimerDownUp = function useTimerDownUp(_ref) {
  var secondsInitial = _ref.secondsInitial,
      _ref$isAscending = _ref.isAscending,
      isAscending = _ref$isAscending === void 0 ? false : _ref$isAscending,
      _ref$delay = _ref.delay,
      delay = _ref$delay === void 0 ? 1000 : _ref$delay,
      _ref$counterUpMax = _ref.counterUpMax,
      counterUpMax = _ref$counterUpMax === void 0 ? 30000 : _ref$counterUpMax;

  var _useState = (0, _react.useState)(Math.floor(secondsInitial / 3600)),
      _useState2 = _slicedToArray(_useState, 2),
      hours = _useState2[0],
      setHours = _useState2[1];

  var _useState3 = (0, _react.useState)(Math.floor(secondsInitial % 3600 / 60)),
      _useState4 = _slicedToArray(_useState3, 2),
      minutes = _useState4[0],
      setMinutes = _useState4[1];

  var _useState5 = (0, _react.useState)(Math.floor(secondsInitial % 3600 % 60)),
      _useState6 = _slicedToArray(_useState5, 2),
      seconds = _useState6[0],
      setSeconds = _useState6[1];

  var _useState7 = (0, _react.useState)(secondsInitial),
      _useState8 = _slicedToArray(_useState7, 2),
      timeLeft = _useState8[0],
      setTimeLeft = _useState8[1];

  var interval = (0, _react.useRef)();
  (0, _react.useEffect)(function () {
    if (timeLeft <= 0 || timeLeft >= counterUpMax) {
      stopTimer();
    }

    var moduleDelta = timeLeft % 3600;
    setHours(Math.floor(timeLeft / 3600));
    setMinutes(Math.floor(moduleDelta / 60));
    setSeconds(Math.floor(moduleDelta % 60));

    if (interval.current === null && timeLeft >= 0 && timeLeft <= counterUpMax) {
      startTimer();
    }
  }, [timeLeft]);
  (0, _react.useEffect)(function () {
    stopTimer();
    reset();
  }, [secondsInitial]);

  var startTimer = function startTimer() {
    if (!interval.current) {
      var timeNowMilliseconds = Date.now();
      interval.current = setInterval(function () {
        var timeNowSeconds = Date.now();
        var timerTranscurrent = Math.round((timeNowSeconds - timeNowMilliseconds) / 1000);

        if (isAscending) {
          setTimeLeft(timeLeft + timerTranscurrent);
        } else {
          setTimeLeft(timeLeft - timerTranscurrent);
        }
      }, delay);
    }
  };

  var stopTimer = function stopTimer() {
    clearInterval(interval.current);
    interval.current = null;
  };

  var reset = function reset() {
    setHours(Math.floor(secondsInitial / 3600));
    setMinutes(Math.floor(secondsInitial % 3600 / 60));
    setSeconds(Math.floor(secondsInitial % 3600 % 60));
    setTimeLeft(secondsInitial);
  };

  var clear = function clear() {
    stopTimer();
    setHours(0);
    setMinutes(0);
    setSeconds(0);
    setTimeLeft(0);
  };

  var zeroPad = function zeroPad(value) {
    return value.toString().padStart(2, '0');
  };

  var fullFormat = function fullFormat() {
    return "".concat(zeroPad(hours), ":").concat(zeroPad(minutes), ":").concat(zeroPad(seconds));
  };

  return {
    timeLeft: timeLeft,
    setTimeLeft: setTimeLeft,
    hours: hours,
    minutes: minutes,
    seconds: seconds,
    startTimer: startTimer,
    stopTimer: stopTimer,
    clear: clear,
    reset: reset,
    fullFormat: fullFormat
  };
};

var _default = useTimerDownUp;
exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./~/global-components-library/dist/hooks/useTimerDownUp.js
// module id = 1938
// module chunks = 0